import React from "react";
import { ToastContainer } from "react-toastify";
import "./App.css";
import RouteApp from "./route/index";

// Um único container de avisos para o app inteiro (antes cada tela tinha o
// seu, e as que não tinham não mostravam os avisos)
const App: React.FC = () => (
  <>
    <RouteApp />
    <ToastContainer position="top-right" autoClose={3000} />
  </>
);

export default App;
